import { render } from "./ServiceSearch.vue?vue&type=template&id=5c035e16&scoped=true"
import script from "./ServiceSearch.vue?vue&type=script&lang=js"
export * from "./ServiceSearch.vue?vue&type=script&lang=js"

import "./ServiceSearch.vue?vue&type=style&index=0&id=5c035e16&scoped=true&lang=css"

import exportComponent from "/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c035e16"]])

export default __exports__